import { TERRITORY } from "$routes/_lib/constants";
import {
  kenyaInsuranceSchemas,
  nigeriaInsuranceSchemas,
  pakistanInsuranceSchemas,
} from "./insurance-form-schemas";

export const INSURANCE_PROVIDERS = {
  [TERRITORY.KENYA]: kenyaInsuranceSchemas,
  [TERRITORY.NIGERIA]: nigeriaInsuranceSchemas,
  [TERRITORY.PAKISTAN]: pakistanInsuranceSchemas,
  [TERRITORY.LIBERIA]: [],
};
